import axios from "axios";
import apiUrlOne from "../../../utils.js/Config";

// Job Categories
export const getJobCategories = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/job-categories/get-all-job-categories-admin`);
        return response.data;
    } catch (error) {
        if (!axios.isCancel(error)) {
            console.error("Error fetching job categories:", error);
        }
        throw error;
    }
};

export const createJobCategory = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/job-categories`, data);
        return response.data;
    } catch (error) {
        console.error("Error creating job category:", error);
        throw error;
    }
};

export const updateJobCategory = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/job-categories/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating job category:", error);
        throw error;
    }
};
export const deleteJobCategory = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/job-categories/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting job category:", error);
        throw error;
    }
};

// Job Roles (Jobs)
export const getJobRoles = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/jobs`);
        return response.data;
    } catch (error) {
        if (!axios.isCancel(error)) {
            console.error("Error fetching job roles:", error);
        }
        throw error;
    }
};

export const getJobRolesByCategory = async (categoryId) => {
    try {
        const response = await axios.get(`${apiUrlOne}/jobs/category/${categoryId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching job roles by category:", error);
        throw error;
    }
};


export const createJobRole = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/jobs`, data);
        return response.data;
    } catch (error) {
        console.error("Error creating job role:", error);
        throw error;
    }
};

export const updateJobRole = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/jobs/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating job role:", error);
        throw error;
    }
};
export const deleteJobRole = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/jobs/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting job role:", error);
        throw error;
    }
};

// Job Enquiries (Applications)
export const getJobApplications = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/job-applications`);
        return response.data;
    } catch (error) {
        if (!axios.isCancel(error)) {
            console.error("Error fetching job applications:", error);
        }
        throw error;
    }
};

export const getJobApplicationsByJob = async (jobId, page = 1, limit = 10) => {
    try {
        const response = await axios.get(`${apiUrlOne}/job-applications/job/${jobId}?page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching job applications by job:", error);
        throw error;
    }
};

export const updateJobApplication = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/job-applications/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating job application:", error);
        throw error;
    }
};
